import { useState } from "react";
import { Box, Button, Card, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useDispatch } from "react-redux";
import { LAYOUT_MARGIN } from "Configs/home";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import useWindowSize from "Hooks/useWindowSize";
import { useAppSelector } from "Hooks/useRedux";
import { setMapData } from "Redux/mapSlice";

import Toolbox from "./Toolbox";
import Tooltip from "../Tooltip";
import { Spectrum, Spectrum2, Spectrum3 } from "../Map/Spectrum";
import Cameras from "./side/cameras";
import MarginPark from "./side/marginPark";
import LocationData from "../LocationData";
import Menu from "../Menu";
import Modals from "../Modals";
import LeftSideController from "./side/leftSideControl";
import SimpleDashboard from "./side/simpleDashboard";
import TrafficPaths from "./side/trafficPaths";
import Stations from "./side/stations";

export default function TrafficAnalysis() {
  const { surveyShowType, visible: surveysVisible, pointwiseShow } = useAppSelector((state) => state.surveys);
  const { fullScreen } = useAppSelector((state) => state.services);
  const { zoom } = useAppSelector((state) => state.map);

  const dispatch = useDispatch();

  const handleMapZoom = (index: number) => {
    const zoomLevel = 0.5;
    const newZoom = index === 0 ? zoom + zoomLevel : zoom - zoomLevel;
    dispatch(setMapData({ zoom: newZoom }));
  };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: fullScreen ? 2 : LAYOUT_MARGIN + 56,
          right: LAYOUT_MARGIN,
          width: fullScreen ? `calc(100% - ${LAYOUT_MARGIN * 2}px)` : "400px",
          zIndex: fullScreen ? "1001" : "",
          transition: "all 0.3s",
        }}
      >
        <SimpleDashboard />
      </Box>
      <Box sx={{ position: "absolute", top: LAYOUT_MARGIN + 56, left: LAYOUT_MARGIN, width: "380px", zIndex: "2" }}>
        <Cameras />
      </Box>
      <Box sx={{ position: "absolute", top: LAYOUT_MARGIN + 56, left: LAYOUT_MARGIN, width: "380px", zIndex: "2" }}>
        <MarginPark />
      </Box>
      <Box sx={{ position: "absolute", top: LAYOUT_MARGIN + 56, left: LAYOUT_MARGIN, width: "380px", zIndex: "2" }}>
        <TrafficPaths />
      </Box>
      <Box sx={{ position: "absolute", top: LAYOUT_MARGIN + 56, left: LAYOUT_MARGIN, width: "380px", zIndex: "2" }}>
        <Stations />
      </Box>
      <Box sx={{ position: "absolute", top: LAYOUT_MARGIN, right: LAYOUT_MARGIN }}>
        <LocationData />
      </Box>
      <Box sx={{ position: "absolute", top: "50%", right: 0, transform: "translateY(-50%)", zIndex: 1000 }}>
        <Menu />
      </Box>
      {surveyShowType === 0 && surveysVisible && !pointwiseShow ? (
        <Stack direction="row" spacing={1} sx={{ width: "40%", position: "absolute", bottom: 110, left: LAYOUT_MARGIN }}>
          <Spectrum3 />
        </Stack>
      ) : null}
      {surveyShowType === 1 && surveysVisible ? (
        <Stack direction="row" spacing={1} sx={{ width: "40%", position: "absolute", bottom: 110, left: LAYOUT_MARGIN }}>
          <Spectrum2 />
        </Stack>
      ) : null}
      {surveyShowType === 2 && surveysVisible ? (
        <Stack direction="row" spacing={1} sx={{ width: "40%", position: "absolute", bottom: 110, left: LAYOUT_MARGIN }}>
          <Spectrum />
        </Stack>
      ) : null}
      <Stack
        direction="row"
        spacing={1}
        sx={{
          width: `calc(100% - ${LAYOUT_MARGIN * 2}px)`,
          position: "absolute",
          bottom: LAYOUT_MARGIN,
          left: LAYOUT_MARGIN,
        }}
      >
        <Tooltip bgcolor="#feb914" />
        <Toolbox />
        <Card component={Stack}>
          {[AddOutlinedIcon, RemoveOutlinedIcon].map((IconTag, index) => (
            <Button
              variant="white"
              sx={{
                p: 0,
                height: "50%",
                borderRadius: 0,
                minWidth: "30px",
                boxShadow: 0,
                borderBottom: index === 0 ? "1px solid #ddd" : null,
                "&:hover": { boxShadow: 0 },
              }}
              onClick={() => handleMapZoom(index)}
            >
              <IconTag sx={{ fontSize: "16px" }} />
            </Button>
          ))}
        </Card>
        {/* <LeftSideController /> */}
        {/* <FleetDialoig /> */}
      </Stack>
      <Modals />
    </>
  );
}
